export default {
  name: 'page1'
};